<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>
    <!-- 顶图 -->
    <YorkbbsImage class="special-banner" :src="special.property.topicBanner[0]"></YorkbbsImage>
    <div class="main">
      <div class="special-summary" v-if="special.content">{{ special.content }}</div>

      <!-- 精华专题 -->
      <dl class="special-module" v-if="special.property.topicNews1.length">
        <dt class="special-header">{{ special.property.topicNews1Name }}</dt>
        <dd class="special-content">
          <div class="special-list">
            <YorkbbsInfoItem
              class="special-item"
              v-for="(item, i) in special.property.topicNews1"
              :key="i"
              :data="item"
            ></YorkbbsInfoItem>
          </div>
        </dd>
      </dl>
      <!-- 最新专题 -->
      <dl class="special-module" v-if="special.property.topicNews2.length">
        <dt class="special-header">{{ special.property.topicNews2Name }}</dt>
        <dd class="special-content">
          <div class="special-list">
            <YorkbbsInfoItem
              class="special-item"
              v-for="(item, i) in special.property.topicNews2"
              :key="i"
              :data="item"
            ></YorkbbsInfoItem>
          </div>
        </dd>
      </dl>
    </div>

    <!-- 工具 -->
    <YorkbbsSpecialTools left="calc(50% - 500px)" top="410px" :post="special"></YorkbbsSpecialTools>

    <!-- 底部 -->
    <YorkbbsFooter></YorkbbsFooter>
  </div>
</template>
<script>
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsInfoItem from './item-info.vue';
import YorkbbsFooter from '@/common/footer/footer-simple.vue';
import YorkbbsSpecialTools from '../components/special-tools.vue';
import {setHtmlMeta} from '@/utils/utils'
export default {
  name: 'SpecialSmall',
  components: { YorkbbsHeader, YorkbbsInfoItem, YorkbbsFooter, YorkbbsSpecialTools },
  data() {
    return {
      // 专题加载状态
      loading: false,
      // 专题详情
      special: {
        content: '',
        property: {
          topicBanner: [],
          topicNews1Name: '',
          topicNews2Name: '',
          topicNews1: [],
          topicNews2: [],
        },
      },
    };
  },
  created() {
    this.getSpecial();
  },
  methods: {
    /**
     * 获取专题详情
     */
    async getSpecial() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/cms/v1/get/topic/post/detail', {
          postId: this.$route.params.id,
          cmsType: 3,
        })
        .finally(() => {
          this.loading = false;
        });
      this.special = { ...this.special, ...data };
      setHtmlMeta({
        title:data.property.seoTitle,
        keywords:data.property.seoKeyword,
        description:data.property.seoDescription
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #f8f8f8;
}
.special-banner {
  width: 100%;
  height: 230px;
}
.main {
  width: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
  margin: -15px auto 0;
  position: relative;
  z-index: 1;
}
.special-summary {
  font-size: 18px;
  line-height: 30px;
  color: var(--text-color-3);
  padding-bottom: 30px;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
  &::before,
  &::after {
    font-size: 50px;
    color: var(--text-color-9);
    position: relative;
    top: 15px;
  }
  &::before {
    content: '“';
  }
  &::after {
    content: '”';
  }
}
.special-module {
  &:not(:last-child) {
    margin-bottom: 50px;
  }
}
.special-header {
  font-size: 32px;
  font-weight: 600;
  line-height: 45px;
  margin-bottom: 50px;
  text-align: center;
}
.special-item {
  &:not(:last-child) {
    margin-bottom: 30px;
  }
}
</style>
